var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.content.pageFaqs && _vm.content.pageFaqs.data && _vm.content.pageFaqs.data.length)?_c('div',{staticClass:"pro-age__list container"},[_c('div',{staticClass:"pro-age__list--main"},[_vm._l((_vm.content.pageFaqs.data),function(faq){return [_c('span',{domProps:{"innerHTML":_vm._s(faq.answer)}})]})],2)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }